import { useParams } from "react-router";

import { useTranslation } from "react-i18next";
import { DocumentBreadcrumbs } from "~/molecules/DocumentBreadcrumbs";
import { DocumentAuditTrailTimeline } from "~/molecules/DocumentAuditTrailTimeline";
import { useDocument } from "~/api/v2/useDocument";
import { CenterSpinner } from "~/atoms/spinner";
import NoResult from "~/molecules/NoResult";

export function DocumentAuditTrailPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const documentId = id ? parseInt(id) : null;
  const { data: document, isLoading } = useDocument(documentId ?? undefined);
  const latestVersion = document?.versions[0];

  if (!documentId) {
    return <div>{t("commons.workflow.invalidDocumentId")}</div>;
  }

  if (isLoading) {
    return <CenterSpinner withText />;
  }

  if (!document || !latestVersion) {
    return <NoResult message={t("commons.noItems")} />;
  }

  return (
    <div className="container space-y-6 py-6">
      <DocumentBreadcrumbs
        documentId={document.id}
        versionId={latestVersion.id}
        title={latestVersion.title}
        additionalBreadcrumbs={[{ label: t("commons.documentHistory.header") }]}
      />
      <h1 className="text-2xl font-bold">
        {t("commons.documentHistory.header")}
      </h1>
      <DocumentAuditTrailTimeline documentId={documentId} />
    </div>
  );
}
